import React from "react";
import "../styles/page404.scss";

const Page404 = () => {
	return (
		<div className="page404">
			<h1>404 page not found</h1>
		</div>
	);
};

export default Page404;
